// components/widgets/primitives/practitioner-lens.js
// ═══════════════════════════════════════════════════════════
// PRACTITIONER LENS — inline expandable callout (DI pattern)
// Replaces boxed "Shift's Read" callouts with a hairline-bracketed
// expander.
// ═══════════════════════════════════════════════════════════

import { useState } from 'react';

export default function PractitionerLens({
  label = 'practitioner lens',
  defaultOpen = true,
  children,
  className = '',
}) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div className={`ws-prim-lens ${open ? 'is-open' : ''} ${className}`}>
      <button
        type="button"
        className="ws-prim-lens-header"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
      >
        <span className="ws-prim-lens-rule" aria-hidden />
        <span className="ws-prim-lens-label">{label}</span>
        <span className="ws-prim-lens-rule ws-prim-lens-rule-grow" aria-hidden />
        <span className="ws-prim-lens-chev" aria-hidden>{open ? '\u25BE' : '\u25B8'}</span>
      </button>
      {open && <div className="ws-prim-lens-body">{children}</div>}
    </div>
  );
}
